import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';

export default class ProductionTracking extends Base {
	constructor(props) {
		super(props);
		this.state = {
			caller: props.Caller,
			controllerName: 'productiontracking',
			id: props.Id,
			data: null,
			loading: true,
		};
		this.keyDownFunction = this.keyDownFunction.bind(this);
	}
	componentWillUnmount() {
		this.removeKeyDown();
	}
	componentDidMount() {
		this.addKeyDown();
		this.httpPost("api/v1/productiontracking/get", {
			id: this.state.id,
		})
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					window.organizationId = data.global.company.id;
					this.state.data = data;
					this.state.loading = false;
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderTbody() {
		var row = 1;
		var list = [];
		this.state.data.sales.forEach(item =>
			item.items.forEach(detail => {
				list.push(<tr key={detail.id}>
					<td>{row++}</td>
					{this.state.data.global.company.mainBussinessType !== 3 && <td>
						{item.fullNumber}
					</td>}
					<td>
						{item.personName}
					</td>
					<td>
						{item.personMobile}
					</td>
					<td>
						{detail.stuffName}
					</td>
					<td>
						{detail.count}
					</td>
					{this.state.data.global.company.mainBussinessType !== 3 && <td>
						{detail.unitName}
					</td>}
					<td>
						{detail.modulusCount}
					</td>
					{this.state.data.global.company.mainBussinessType !== 3 && <td>
						{detail.modulusUnitName}
					</td>}
				</tr>
				);
			}));
		return list;
	}
	renderForm() {
		return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
			<div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
			<div className="modal-dialog ui-draggable" style={{ "width": "96%", "left": "7.125px", "top": "-2px" }}>
				<div className="modal-content">
					<div className="modal-body">
						<div className="modal-header modal-header-info" style={{ "padding": "0" }}>
							<button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
							<h4 className="modal-title">گزارش خروج کالا</h4>
						</div>
						<div className="modal-body" style={{ "display": "flex", "flex-direction": "column", "gap": "10px" }}>
							<div className="row">
								<div className="col-sm-4">
									<div className="form-group">
										{this.state.data.global.company.mainBussinessType !== 3 ?
											<label for="invoiceNumber" className="title1">شماره: {this.state.data.record.fullNumber}</label>
											:
											<label for="invoiceNumber" className="title1">شماره کشت: {this.state.data.record.fullNumber}</label>
										}
									</div>
								</div>
								<div className="col-sm-4">
									<div className="form-group">
										<label for="invoiceNumber" className="title1">تاریخ: {this.state.data.record.dateString}</label>
									</div>
								</div>
								<div className="col-sm-4">
									<div className="form-group">
										{this.state.data.global.company.mainBussinessType !== 3 ?
											<label for="invoiceNumber" className="title1">خطوط تولید: {this.state.data.record.productionLines.map(p => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "2px 10px", "display": "inline-block" }}>{p.label}</span>)}</label>
											:
											<label for="invoiceNumber" className="title1">{this.state.data.record.productionLines.map(p => <span style={{ "background-color": "#f8a602", "border-radius": "4px", "padding": "2px", "margin": "2px 10px", "display": "inline-block" }}>{p.label}</span>)}</label>
										}
									</div>
								</div>
							</div>
							<div className="row mr-b-20">
								<div className="col-md-12">
									<label className="title1">توضیحات: {this.state.data.record.description}</label>
								</div>
							</div>
							<div className="tab-content">
								<div className="tab-pane active" id="base">
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td style={{ "width": "40px" }}>ردیف</td>
												{this.state.data.global.company.mainBussinessType !== 3 && <td>شماره سفارش</td>}
												<td>نام مشتری</td>
												<td>شماره موبایل</td>
												<td>کالا</td>
												{this.state.data.global.company.mainBussinessType !== 3 ? <td>تعداد اصلی</td> : <td>تعداد بلوک/کیسه</td>}
												{this.state.data.global.company.mainBussinessType !== 3 && <td>واحد اصلی</td>}
												{this.state.data.global.company.mainBussinessType !== 3 ? <td>تعداد فرعی</td> : <td>کیلوگرم</td>}
												{this.state.data.global.company.mainBussinessType !== 3 && <td>واحد فرعی</td>}
											</tr>
										</thead>
										<tbody>
											{this.renderTbody()}
										</tbody>
									</table>
								</div>
							</div>

							<div className="row">
								{this.state.data.global.company.mainBussinessType !== 3 && <div className="col-lg-6 col-md-6 col-sm-12">
									<h4>مجموع به تفکیک واحد اصلی</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>آیتم</td>
												<td>مجموع مقدار</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.sumByUnit.map(cost => <tr>
												<td>{cost.unitName}</td>
												<td>{cost.totalCount}</td>
											</tr>)}
										</tbody>
									</table>
									<h4>مجموع به تفکیک واحد فرعی</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>آیتم</td>
												<td>مجموع مقدار</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.sumByModulusUnit.map(cost => <tr>
												<td>{cost.modulusUnitName}</td>
												<td>{cost.totalModulusCount}</td>
											</tr>)}
										</tbody>
									</table>
								</div>}
								<div className="col-lg-6 col-md-6 col-sm-12">
									<h4>جمع کل محصولات</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>آیتم</td>
												{this.state.data.global.company.mainBussinessType !== 3 ? <td>مجموع مقدار اصلی</td> : <td>تعداد بلوک/کیسه</td>}
												{this.state.data.global.company.mainBussinessType !== 3 ? <td>مجموع مقدار فرعی</td> : <td>کیلوگرم</td>}
												<td>میانگین</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.sumByStuff.map(cost => <tr>
												<td>{cost.stuffName}</td>
												<td>{cost.totalCount}</td>
												<td>{cost.totalModulusCount}</td>
												<td>{this.FixedPointNumber((cost.totalModulusCount / cost.totalCount), 2)}</td>
												{/*<td>{cost.modulusCountAvrage}</td>*/}										
											</tr>)}
										</tbody>
									</table>
									<h4>حمل و نقل</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>ردیف</td>
												{this.state.data.global.company.mainBussinessType !== 3 && <td>شماره سفارش</td>}
												<td>نام مشتری</td>
												<td>نام راننده</td>
												<td>کرایه</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.sales.map((item, index) =>
												<tr key={item.id}>
													<td>{index + 1}</td>
													{this.state.data.global.company.mainBussinessType !== 3 && <td>
														{item.fullNumber}
													</td>}
													<td>
														{item.personName}
													</td>
													<td>
														{item.driverName}
													</td>
													<td>
														{this.money(item.driverCost)}
													</td>
												</tr>
											)}
										</tbody>
									</table>
								</div>
								<div className="col-lg-6 col-md-6 col-sm-12">
									<h4>اقلام مصرفی</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>آیتم</td>
												<td>شرح</td>
												<td>واحداصلی</td>
												<td>تعداد</td>
												<td>واحدفرعی</td>
												<td>تعداد</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.productionItems.map(cost => <tr>
												<td>{cost.stuffName}</td>
												<td>{cost.description}</td>
												<td>{cost.unitName}</td>												
												<td>{cost.count}</td>
												<td>{cost.modulusUnitName}</td>
												<td>{cost.modulusCount}</td>
											</tr>)}
										</tbody>
									</table>
								</div>
								{this.state.data.global.company.mainBussinessType !== 3 && <div className="col-lg-6 col-md-6 col-sm-12">
									<h4>هزینه های مستقیم</h4>
									<table className="table table-bordered acc_grid_row">
										<thead>
											<tr className="active">
												<td>آیتم</td>
												<td>شرح</td>
												<td>تعداد</td>
												<td>مبلغ</td>
												<td>جمع کل</td>
											</tr>
										</thead>
										<tbody>
											{this.state.data.record.costs.map(cost => <tr>
												<td>{cost.stuffName}</td>
												<td>{cost.description}</td>
												<td>{cost.count}</td>
												<td>{this.money(cost.price)}</td>
												<td>{this.money(cost.total)}</td>
											</tr>)}
										</tbody>
									</table>
								</div>}
							</div>
						</div>
						<div className="modal-footer">
							{this.state.data.global.company.mainBussinessType === 3 && <a onClick={e => this.getPdf(this.state.id)} className="btn btn-danger"><span>PDF</span></a>}
							<a className="btn btn-warning" onClick={e => this.closeMe()}>برگشت</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				this.getGlobalContainer(),
				this.renderForm(),
				this.renderPopupComponent()
			];

		return contents;
	}
}